<template>
  <div>
    <div class="wrapper">
      <font-awesome-icon class="icon" :icon="['fas', $props.icon]" />
      <h3 class="question" v-html="$props.question"></h3>
      <CountInput :counter.sync="counterVal"></CountInput>
    </div>
  </div>
</template>

<script>
import CountInput from "./CountInput";
export default {
  name: "CountIconInput",
  components: { CountInput },
  props: {
    question: {
      type: String,
      required: true
    },
    counter: {
      type: Number,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      counterVal: this.counter
    };
  },
  watch: {
    counterVal: function() {
      this.$emit("update:counter", this.counterVal);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
}
.count-image {
  max-height: 400px;
  border-radius: 10px;
  border: 1px solid $color-black;
  margin: 20px;
}

@media only screen and (max-width: 768px) {
  .count-image {
    max-width: 60%;
  }
}

.icon {
  color: $color-primary;
  width: 26px;
  height: 26px;
  cursor: pointer;
}

.question {
  padding: 0 20px 0 20px;
  width: 140px;
  text-align: left;
}
</style>
